import { Button, Chip, Stack } from '@mui/material';
import { compact, isEmpty, values } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';

import { relayDeliveryMethodLabel, relayStatusLabel } from 'common/constants/relayOrders';
import { updateRelayQueueFilter } from 'store/thunks/workQueueThunks';

/** POM-6279 — the relay queue's applied filters as chips, like the other queues' status bars. */
const RelayOrdersFilterStatusBar = () => {
  const dispatch = useDispatch();
  const filter = useSelector(({ workQueue }) => workQueue.relayQueue.filter);

  const removeFilter = (filterName) => () =>
    dispatch(updateRelayQueueFilter({ filter: { ...filter, [filterName]: undefined } }));

  const removeAllFilter = () => dispatch(updateRelayQueueFilter({ filter: {} }));

  const hasActiveFilters = !isEmpty(compact(values(filter)));

  return (
    <Stack spacing={1} direction='row' flexWrap='wrap' rowGap={1} alignItems='center'>
      {!isEmpty(filter?.statuses) && (
        <Chip
          label={`Status = ${filter.statuses.map(relayStatusLabel).join(', ')}`}
          onDelete={removeFilter('statuses')}
        />
      )}

      {!isEmpty(filter?.deliveryMethods) && (
        <Chip
          label={`Relay Type = ${filter.deliveryMethods.map(relayDeliveryMethodLabel).join(', ')}`}
          onDelete={removeFilter('deliveryMethods')}
        />
      )}

      {filter?.patientNameContains && (
        <Chip
          label={`Patient Name = ${filter.patientNameContains}`}
          onDelete={removeFilter('patientNameContains')}
        />
      )}

      {filter?.partnerNameContains && (
        <Chip
          label={`Partner Name = ${filter.partnerNameContains}`}
          onDelete={removeFilter('partnerNameContains')}
        />
      )}

      {filter?.drugNameContains && (
        <Chip
          label={`Drug Name = ${filter.drugNameContains}`}
          onDelete={removeFilter('drugNameContains')}
        />
      )}

      {hasActiveFilters && <Button onClick={removeAllFilter}>Remove All</Button>}
    </Stack>
  );
};

export default RelayOrdersFilterStatusBar;
